import { PurchaseOrder } from '../type/purchase-order'
import type { PresetColorType } from 'antd/es/_util/colors'

export const purchaseOrderStatusMapper: Record<PurchaseOrder['status'], PresetColorType> = {
  Pending: 'yellow',
  Confirmed: 'blue',
  PartiallyReceived: 'purple',
  Completed: 'green',
}

export const purchaseOrderStatusLabelMapper: Record<PurchaseOrder['status'], string> = {
  Pending: 'Pending',
  Confirmed: 'Confirmed',
  PartiallyReceived: 'Partially Received',
  Completed: 'Received Complete',
}